<template>
  <div class="content fix-minHeight" @click="toggleSidebar">
    <div class="container-fluid">
      <div class="row">
        <div class="col-md-8">
          <div class="card">
            <div class="content" dir="rtl" style="text-align: right;">
              <div class="organize">
                <h4>ویرایش اطلاعات:</h4>
                <div class="row">
                  <div class="col-md-12">
                    <form @submit.prevent="submitForm">
                      <div class="form-group label-floating">
                        <!-- <label class="control-label">نام کاربری</label>
                        <input type="text" class="form-control" v-model="user.username"> -->
                        <label class="control-label">نام کامل</label>
                        <input type="text" class="form-control" v-model="user.fullname">
                        <label class="control-label">شماره تماس</label>
                        <input type="text" class="form-control" v-model="user.phone">
                        <label class="control-label">بیوگرافی</label>
                        <textarea class="form-control" v-model="user.bio"></textarea>
                        <div class="row">
                          <label for="tags" class="formInput">برچسب ها:</label>
                          <p class="link" @click="add_skill">افزودن برچسب جدید به پایگاه داده</p>
                        </div>
                        <div class="form-control formInput tagsArea" id="tags_holder">
                          <p v-for="skill in selected_skills" :key="skill.id" class="tag"
                            @click="removeSkill(skill.id)">
                            {{ skill.name }}
                            <i class="fa fa-times" aria-hidden="true" style="color: red;"
                              @click="removeSkill(skill.id)"></i>
                          </p>
                          <p v-if="selected_skills.length === 0">حداقل یک برچسب انتخاب کنید</p>
                        </div>
                        <select class="form-control formInput" id="tags" @change="selectSkill">
                          <option>انتخاب کنید</option>
                          <option v-for="skill in Skills" :key="skill.id" :value="skill.id">{{ skill.name }}
                          </option>
                        </select>
                        <div class="row">
                          <div class="col-md-6">
                            <label for="password">رمز عبور</label>
                            <input type="password" class="form-control" id="password" placeholder="رمز عبور">
                          </div>
                          <div class="col-md-6">
                            <label for="password_confirmation">تکرار رمز عبور</label>
                            <input type="password" class="form-control" id="password_confirmation"
                              placeholder="تکرار رمز عبور">
                          </div>
                        </div>
                      </div>
                      <button type="submit" class="btn btn-primary">ارسال</button>
                    </form>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="col-md-4">
          <div class="card">
            <div class="image-background">
              <div class="overlay"></div>
              <img src="/img/profile-background.jpg" alt="profile-background" class="img-responsive">
            </div>
            <div class="content">
              <div class="author">
                <img class="avatar border-gray" :src="user.avatar ? user.avatar : '/img/default-avatar.png'"
                  alt="avatar" onerror="this.src='/img/default-avatar.png'">
                <h4 class="title">{{ user.username }}<br />
                  <small>{{ user.fullname }}</small>
                </h4>
              </div>
              <p class="description text-center">
                {{ user.bio }}
              </p>
              <p class="text-center">
                <i class="fa fa-phone"></i> {{ user.phone }}
              </p>
              <div class="col-md-10">
                <b>Skills:</b>
                  <p v-for="skill in user.skills" :key="skill.id" class="label label-info skills-list">{{ skill.name }} </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from 'axios';
import { Apis } from '../constants';

export default {
  data() {
    return {
      user: {
        id: localStorage.getItem('userID'),
        username: 'michael23',
        fullname: 'Mike Andrew',
        avatar: '/img/default-avatar.png',
        phone: '123-456-7890',
        bio: 'Lamborghini Mercy, Your chick she so thirsty, I\'m in that two seat Lambo.',
        skills: [],
      },
      selected_skills: [],
      Skills: []
    }
  },
  mounted() {
    this.$loading.show();
    axios.get(Apis.get_user_info + this.user.id, {
      withCredentials: true
    }).then(response => {
      this.user = response.data;
      axios.get(Apis.get_skills, {
        withCredentials: true
      }).then(response => {
        if (response.data.result == undefined) {
          this.Skills = response.data;
          for (let i = 0; i < this.user.skills.length; i++) {
            this.selected_skills.push(this.user.skills[i]);
            this.Skills = this.Skills.filter(item => item.id != this.user.skills[i].id);
          }
        }
      }).catch(error => {
        console.log(error);
      });
    }).catch(error => {
      console.log(error);
    }).finally(() => {
      this.$loading.hide();
    });



  },
  methods: {
    toggleSidebar() {
      if (this.$sidebar.showSidebar) {
        this.$sidebar.displaySidebar(false)
      }
    },
    selectSkill() {
      const selected = document.getElementById('tags');
      const selected_id = selected.options[selected.selectedIndex].value;
      const selected_name = selected.options[selected.selectedIndex].text;
      const skill = { id: selected_id, name: selected_name };
      this.selected_skills.push(skill);
      this.Skills = this.Skills.filter(item => item.id != skill.id);
    },
    removeSkill(id) {
      const skill = this.selected_skills.find(skill => skill.id === id);
      this.selected_skills = this.selected_skills.filter(skill => skill.id !== id);
      this.Skills.push(skill);
    },
    add_skill() {
      let skill = prompt('نام برچسب جدید را وارد کنید');
      if (skill) {
        let form = new FormData();
        form.append('name', skill);
        axios.post(Apis.skills_add, form, {
          withCredentials: true
        }).then(response => {
          this.Skills = response.data;
          console.log(response.data);
        }).catch(error => {
          console.log(error);
        });
      }
    },
    validateFormData() {
      let password = document.getElementById('password').value;
      let password_confirmation = document.getElementById('password_confirmation').value;
      if (password != "" && password_confirmation != "" && password != password_confirmation) {
        this.$notifications.notify(
          {
            message: `<span><b>خطا</b>, رمز عبور و تکرار آن باید یکسان باشند.</span>`,
            icon: 'nc-icon nc-notification-70 ',
            horizontalAlign: 'right',
            verticalAlign: 'top',
            type: 'danger'
          });
        return false;
      }
      return true;
    },
    submitForm() {
      if (this.validateFormData()) {
        this.$loading.show();
        let form = new FormData();
        // form.append('username', this.user.username);
        form.append('fullname', this.user.fullname);
        form.append('phone', this.user.phone);
        form.append('bio', this.user.bio);
        form.append('skills', this.selected_skills.map(skill => skill.id).join(','));
        form.append('password', document.getElementById('password').value);
        axios.post(Apis.update_user_info, form, {
          withCredentials: true
        }).then(response => {
          console.log(response);
          this.user = response.data;
        }).catch(error => {
          console.log(error);
        }).finally(() => {
          this.$loading.hide();
        });
      } else {
        this.$notifications.notify(
          {
            message: `<span><b>خطا</b>, رمز عبور و تکرار آن باید یکسان باشند.</span>`,
            icon: 'nc-icon nc-notification-70 ',
            horizontalAlign: 'right',
            verticalAlign: 'top',
            type: 'danger'
          });
      }
    }

  }
}

</script>

<style lang="scss" scoped>
.organize {
  padding: 20px;

  .formInput {
    margin-top: 20px;
  }

  .tagsArea {
    display: flex;
    flex-wrap: wrap;
    height: auto;

    .tag {
      margin: 5px;
      padding: 5px 10px;
      border: 1px solid #ccc;
      border-radius: 5px;
      cursor: pointer;
    }
  }

  .link {
    color: #007bff;
    cursor: pointer;
    font-size: small;
    margin-top: auto;
    margin-bottom: auto;
    margin-right: 20px;
  }

}

$height: 150px;

.fix-minHeight {
  min-height: calc(100vh - 100px);
  overflow: hidden;

  .card {
    margin-top: 20px;
    border-radius: 10px;
    overflow: hidden;

    .author {
      text-align: center;
      margin-top: -20px;
      margin-bottom: 20px;
    }

    .image-background {
      height: $height;
      width: 100%;
      overflow: hidden;

      .overlay {
        background-color: rgb(153 151 150 / 50%);
        position: absolute;
        width: 100%;
        height: $height;
      }
    }

    .img-responsive {
      width: 100%;
      height: auto;
    }

    .avatar {
      width: 100px;
      height: 100px;
      border-radius: 50%;
      border: 4px solid #fff;
      margin-top: -50px;
      margin-left: 15px;
      position: relative;
      vertical-align: middle;
      display: inline-block;
    }

    .border-gray {
      border-color: #e5e5e5;
    }

    .skills-list {
      margin-bottom: 5px;
      margin-top: 5px;
      margin-left: 20px;
    }

    .content {
      padding: 15px 20px;
    }

  }
}
</style>
